import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "splash-page" }
const _hoisted_2 = {
  key: 0,
  class: "splash-hero"
}
const _hoisted_3 = { class: "splash-cta" }
const _hoisted_4 = { class: "splash-footer" }
const _hoisted_5 = {
  key: 1,
  class: "setup-card casino-card-glow"
}
const _hoisted_6 = { class: "setup-title" }
const _hoisted_7 = { class: "setup-subtitle text-muted" }
const _hoisted_8 = {
  key: 0,
  class: "setup-form"
}
const _hoisted_9 = {
  key: 1,
  class: "setup-form"
}
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "overlay"
}
const _hoisted_13 = { class: "setup-card casino-card-glow modal-card" }
const _hoisted_14 = { class: "mnemonic-grid" }
const _hoisted_15 = {
  key: 1,
  class: "browser-saved-note"
}
const _hoisted_16 = { class: "checkbox-label" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.mode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"splash-badge\" data-v-3498dc25><span class=\"badge-dot\" data-v-3498dc25></span><span class=\"badge-text\" data-v-3498dc25>POWERED BY ARKADE</span></div><h1 class=\"splash-title\" data-v-3498dc25> The trustless<br data-v-3498dc25><span class=\"title-accent\" data-v-3498dc25>Bitcoin casino.</span></h1><p class=\"splash-tagline\" data-v-3498dc25> Non-custodial. No accounts. No KYC. Every flip is settled by Bitcoin script + an Arkade-script covenant — the operator can’t cheat you, can’t hold your funds, and can’t stall you out. </p><ul class=\"splash-points\" data-v-3498dc25><li data-v-3498dc25><span class=\"point-icon\" data-v-3498dc25>⚡</span><span data-v-3498dc25><strong data-v-3498dc25>Lightning-fast offchain play.</strong> Funds live on Ark — flips settle in seconds without touching the chain. </span></li><li data-v-3498dc25><span class=\"point-icon\" data-v-3498dc25>🔒</span><span data-v-3498dc25><strong data-v-3498dc25>You hold the keys.</strong> Your wallet stays in your browser. The house never sees your secret. </span></li><li data-v-3498dc25><span class=\"point-icon\" data-v-3498dc25>🎲</span><span data-v-3498dc25><strong data-v-3498dc25>Provably fair on-chain.</strong> The win is decided by a covenant arkd &amp; the emulator both verify — no trust required. </span></li></ul>", 4)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn-gold btn-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mode = 'create'))
            }, " Create wallet to play "),
            _createElementVNode("button", {
              class: "btn-text",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'restore'))
            }, " I already have a key ")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/how-it-works",
              class: "link-muted"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("How it works", -1)
              ]))]),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "dot" }, "·", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("a", {
              href: "https://github.com/ArkLabsHQ/coinflip",
              target: "_blank",
              rel: "noopener",
              class: "link-muted"
            }, "Open source", -1))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "setup-brand" }, [
            _createElementVNode("span", { class: "brand-icon" }, "₿")
          ], -1)),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.mode === 'create' ? 'Create wallet' : 'Restore wallet'), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.mode === 'create' ? 'A fresh keypair, stored in your browser only.' : 'Paste your recovery phrase (or nsec) to recover an existing wallet.'), 1),
          (_ctx.mode === 'create')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "warning-box" }, " Your recovery phrase will be shown once. Save it securely! ", -1)),
                _createElementVNode("button", {
                  class: "btn-gold btn-lg",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createWallet && _ctx.createWallet(...args))),
                  style: {"width":"100%"}
                }, " Generate Wallet "),
                _createElementVNode("button", {
                  class: "btn-outline",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = '')),
                  style: {"width":"100%"}
                }, "Back")
              ]))
            : _createCommentVNode("", true),
          (_ctx.mode === 'restore')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.privateKey) = $event)),
                  placeholder: "Recovery phrase or nsec…"
                }, null, 512), [
                  [_vModelText, _ctx.privateKey]
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-primary btn-lg",
                  disabled: !_ctx.privateKey,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.restoreWallet && _ctx.restoreWallet(...args))),
                  style: {"width":"100%"}
                }, " Restore ", 8, _hoisted_11),
                (_ctx.credentialBackupSupported)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn-outline",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.importFromBrowser && _ctx.importFromBrowser(...args))),
                      style: {"width":"100%"}
                    }, " Import from browser "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-outline",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mode = '')),
                  style: {"width":"100%"}
                }, "Back")
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showPrivateKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "modal-title text-gold" }, "Your Recovery Phrase", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "modal-desc text-muted" }, "Save these 12 words securely, in order. They are the only way to recover your wallet!", -1)),
                _createElementVNode("div", {
                  class: "key-box",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.copyKey && _ctx.copyKey(...args)))
                }, [
                  _createElementVNode("ol", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phraseWords, (word, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: "mnemonic-word"
                      }, _toDisplayString(word), 1))
                    }), 128))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "key-hint" }, "Click to copy all", -1))
                ]),
                (_ctx.credentialBackupSupported && !_ctx.savedToBrowser)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-outline",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveToBrowser && _ctx.saveToBrowser(...args))),
                      style: {"width":"100%"}
                    }, " Also save to browser "))
                  : (_ctx.savedToBrowser)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "✓ Sent to your browser — check your saved passwords to confirm"))
                    : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hasBackedUp) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.hasBackedUp]
                  ]),
                  _cache[19] || (_cache[19] = _createTextVNode(" I have safely stored my recovery phrase ", -1))
                ]),
                _createElementVNode("button", {
                  class: "btn-gold btn-lg",
                  disabled: !_ctx.hasBackedUp,
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args))),
                  style: {"width":"100%"}
                }, " Continue ", 8, _hoisted_17)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}